import React from 'react'
import '../styles/footer.css'
const Footer = () => {
  return (
    <div> 
          <footer>
    <nav>
      <div className="nav-links-container">
        <ul className="nav-links">
            
        <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#skills">Skills</a></li>
          <li><a href="#projects">Projects</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
    </nav>
    <p>Copyright &#169; 2023 Prashant Singh Ranawat. All Rights Reserved.</p>
  </footer></div>
  )
}

export default Footer